var Button          = require("./Button");
var $               = require("jquery");

var defaultOptions = {
	/* Текст для кнопки */
	label: 'LabelButton',
	/* Иконка для дропдауна (
			false - блок с иконкой не отрендерится
			true (default) - блок с иконкой отрендерится, но src иконке не 
							 заполнится
			string - блок отрендерится и значение переменной подставится в src
					 картинки
		) 
	*/
	icon: false,
	iconActive: false,
	/* Обработчик клика по кнопке (функция) */
	onclick: false,
    /* Дополнительные стили для кнопки */
    css: {}
};

/* 
	Этот компонент не отличается от обычного Button'a за
	исключением того, что в него можно передать иконку и лейбл
	для отображения. Если в компонент не передать ни то ни другое,
	то компонент отрендерится как обычный omjs.Widget.Button
 */
var LabelButton = Button.extend({

    statics: {
        DEFAULT_OPTIONS: defaultOptions
    },

	initialize: function(options){
		var that = this;
		options = options = $.extend({}, defaultOptions, (options || {}));
		LabelButton.__super__.initialize.call(that, options);

		var $container = that.getContainer();

        $container.css(that.options.css);
		
		/* Если есть или иконка или текст для кнопки,
		 то добавляем класс лейбла */
		if (that.options.icon || that.options.label) {
			$container.addClass('omjs-label-button');
		}

		if (that.options.icon) {
			that.$icon_container = $(that.generateIcon());
			$container.append(that.$icon_container);
		}

		if (that.options.label) {
			that.$label_container = $(that.generateLabel());
			$container.append(that.generateLabel());
		}

		$container.on('click', function(event){
			if (that.options.onclick && _.isFunction(that.options.onclick)) {
				that.options.onclick();
			}
			that.fire('click', event);
		});
		
	},

	generateIcon: function(){
		var that = this;
		var icon_path = that.options.icon;

		var outerElement = document.createElement('div');
			outerElement.className = 'icon-wrapper';

		if (_.isString(icon_path)) {
			var imageElement = document.createElement('img');
				imageElement.src = icon_path;

			outerElement.appendChild(imageElement);
		}

		return outerElement;
	},

	generateLabel: function(){
		var that = this;
		var label_text = that.options.label;

		var outerElement = document.createElement('div');
			outerElement.className = 'label-wrapper';

		outerElement.textContent = label_text;

		/* Если есть иконка, то блоку с текстом нужно
		 сделать отступ чтоб не сливалось */
		if (that.options.icon) {
			outerElement.style.paddingLeft = '7px';
		}

		return outerElement;
	},

	getIcon: function(){
		return this.options.icon;
	},

	getActiveIcon: function(){
		return this.options.iconActive;
	},

	setActiveIcon: function(){
		// if (this.options.activeIcon) {
			var img = this.$icon_container.find('img');
			img.attr('src', this.options.iconActive);
		// } else {
			// console.warn('Не задана иконка iconActive', this.options.activeIcon, $.extend({}, this.options));
		// }
	},

	unsetActiveIcon: function(){
		// if (this.options.icon) {
			var img = this.$icon_container.find('img');
			img.attr('src', this.options.icon);
		// } else {
			// console.warn('Не задана иконка icon', this.options.icon, $.extend({}, this.options)); 
		// }
	}
});

module.exports = LabelButton;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/LabelButton.js
// module id = 206
// module chunks = 0